/* eslint-disable default-case */
import { Model, attr } from "redux-orm";
import propTypesMixin from "redux-orm-proptypes";
import { Types } from "../actionTypes";
import { categoryKeys, Subscriptions } from "@Src/constants";

const ValidatingModel = propTypesMixin(Model);

const ORMCategoryMapper = (apiResponse) => {
  const categories = [...(apiResponse.hasOwnProperty("categories") ? apiResponse.categories : [])];

  const setRootandSubCategories = () => {
    // Root categories: Map special keys and filter categories based on subscription
    const rootCategories = categories.reduce((accum, category) => {
      const { subscription } = apiResponse?.info;
      let subscriptionCategories = [categoryKeys.EAT, categoryKeys.PLAY, categoryKeys.SHOP];
      if (category.category_parent_key === 0) {
        category.subcategories = [];
        if (subscriptionCategories.includes(category.category_key)) {
          // Subscription response from categories api should either include the category ui_name (eat , play, shop) or basic
          const shouldAddCategory =
            subscription.includes(category.ui_name?.toLowerCase()) ||
            subscription.includes(Subscriptions.TRANSACTIONAL.toLowerCase()) ||
            subscription.includes(Subscriptions.BASIC.toLowerCase());

          if (shouldAddCategory) {
            accum.push(category);
          }
        } else {
          accum.push(category);
        }
      }

      return accum;
    }, []);

    // Maps subcategories to root categories
    categories.forEach((category) => {
      rootCategories.forEach((rootCategory) => {
        if (rootCategory.category_key === category.category_parent_key) {
          rootCategory.subcategories.push(category);
        }

        // Sort subcats in alphabetical order
        rootCategory.subcategories.sort((a, b) => a.category_name.localeCompare(b.category_name));
      });
    });

    return rootCategories;
  };

  const rootCategories = setRootandSubCategories();

  return {
    info: apiResponse.info,
    categories: [...rootCategories],
  };
};
export default class OrmCategory extends ValidatingModel {
  static reducer(action, OrmCategory) {
    const { type } = action;
    switch (type) {
      case Types.FETCHING_CATEGORIES:
        return {
          isFetchingCategories: true,
        };
      case Types.FETCHING_CATEGORIES_SUCCESS: {
        const data = ORMCategoryMapper(action.data);
        // categories and subcategories are all together
        return data.categories.map((category) => {
          var hasChildren = false;
          if (category.subcategories?.length > 0) {
            hasChildren = true;
          }
          OrmCategory.upsert({
            id: category.category_key,
            name: category.category_name,
            hasChildren: hasChildren,
            parentCategory: 0,
          });

          return category.subcategories.map((subcategory) => {
            return OrmCategory.upsert({
              id: subcategory.category_key,
              name: subcategory.category_name,
              hasChildren: false,
              parentCategory: category.category_key,
            });
          });
        });
      }
    }
  }
}

OrmCategory.modelName = "OrmCategory";

OrmCategory.fields = {
  id: attr(),
  name: attr(),
  hasChildren: attr(),
  parentCategory: attr(),
};
